"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxItem = exports.CheckboxList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Checkbox_1 = require("../../Checkbox");
var mobx_react_1 = require("mobx-react");
var BootstrapHelper_1 = require("../../../BootstrapHelper");
var CheckboxList = (0, mobx_react_1.observer)(function (props) {
    var cls = (0, BootstrapHelper_1.B)().bl("checkbox-list");
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "".concat(cls.bem) }, { children: [props.header && ((0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": "checkboxlist-header", className: "".concat(cls.el("header").bem) }, { children: props.header }))), (0, jsx_runtime_1.jsx)("ul", __assign({ className: "".concat(cls.el("list").bem) }, { children: props.options.map(function (e) {
                    return ((0, jsx_runtime_1.jsx)(CheckboxItem, __assign({ isChecked: e.isChecked, onClick: function () {
                            props.onItemClick(e);
                        } }, { children: e.label }), e.label));
                }) }))] })));
});
exports.CheckboxList = CheckboxList;
var CheckboxItem = (0, mobx_react_1.observer)(function (props) {
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ "data-testid": "checkbox-list__item", className: "checkbox-list__item ".concat(props.className || ""), onClick: props.onClick && props.onClick }, { children: [(0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { onChange: function () { }, checked: props.isChecked }), props.children] })));
});
exports.CheckboxItem = CheckboxItem;
